import { useEffect } from "react";

interface UseEmailConnectReturnOptions {
  onConnected?: () => void;
  onError?: (message: string) => void;
}

export function useEmailConnectReturn({
  onConnected,
  onError,
}: UseEmailConnectReturnOptions): void {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const result = params.get("email");
    if (!result) return;

    const message = params.get("message");
    params.delete("email");
    params.delete("message");
    const nextSearch = params.toString();
    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}${nextSearch ? `?${nextSearch}` : ""}`,
    );

    if (result === "connected") onConnected?.();
    if (result === "error") onError?.(message ? decodeURIComponent(message) : "Email connection failed.");
  }, [onConnected, onError]);
}

